module.exports = __webpack_public_path__ + "images/doctor_a140f60.svg";